import { BUILDING_API, getData } from 'src/Utils';
import { useQuery } from 'react-query';
import { useMemo } from 'react';
export var useBuildingOptions = function () {
    var _a = useQuery([BUILDING_API], function () { return getData('/buildings'); }, {
        refetchOnWindowFocus: false,
    }), data = _a.data, isLoading = _a.isLoading;
    var buildingOptions = useMemo(function () {
        return (data === null || data === void 0 ? void 0 : data.buildings) ? data.buildings.map(function (building) { return ({
            label: building.name,
            value: building.id,
        }); })
            : [];
    }, [data]);
    return { isLoading: isLoading, buildingOptions: buildingOptions };
};
